/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { WorkorderFromJSON, WorkorderToJSON, } from './';
export function StartLaborTimerCommandFromJSON(json) {
    return StartLaborTimerCommandFromJSONTyped(json, false);
}
export function StartLaborTimerCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'timerStartDateTime': !exists(json, 'timerStartDateTime') ? undefined : (new Date(json['timerStartDateTime'])),
        'workorder': !exists(json, 'workorder') ? undefined : WorkorderFromJSON(json['workorder']),
    };
}
export function StartLaborTimerCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'timerStartDateTime': value.timerStartDateTime === undefined ? undefined : (value.timerStartDateTime.toISOString()),
        'workorder': WorkorderToJSON(value.workorder),
    };
}
